// extracted by mini-css-extract-plugin
export default {"slide":"fYp6k","card":"FrIHP","title":"mTyVJ","text":"WSHQV","card-active":"c85Sd","animation":"q4cd1"};